



































































































































































import Super from "@/pv4-super-class"
import { Component } from "vue-property-decorator"

import {
  parseISO,
  format,
  parseJSON,
  endOfWeek,
  endOfToday,
  startOfToday
} from "date-fns"
import { find, filter } from "lodash"

import TaskReview from "./TaskReview.vue"

import Pagination from "@/components/Pagination.vue"

@Component({ components: { Pagination } })
export default class TaskMy extends Super {
  tasks: any = null
  includeCompleted = false

  currentPage = 1
  itemsPerPage = 5

  mounted() {
    this.load()
  }

  load() {
    this.http
      .get(`/task?eventID=${this.eventId}`)
      .then(res => (this.tasks = res.data))
  }

  //allows the user to reviews te details of the task
  openTaskReviewer(task: any) {
    let params = {
      parent: this,
      component: TaskReview,
      props: {
        eventId: this.eventId,
        taskID: task.taskID,
        userID: task.taskAssigneeID,
        taskAssignerID: task.taskAssignerID,
        taskDependentID: task.taskDependencyID
      }
    }
    this.$buefy.modal.open(params).$on("close", this.load)
  }

  //How many tasks are marked as incomplete for the user
  countTasks(userID: string | number) {
    let counter = 0
    this.tasks.forEach(task => {
      if (userID == task.taskAssigneeID) {
        if (task.taskStatus == 0) {
          counter++
        }
      }
    })
    return counter
  }

  //how many tasks are marked as incomplete for the user and are due before the end of the week (Sunday)
  tasksDueThisWeek(userID: string | number) {
    let counter = 0
    let currentDate = new Date()

    this.tasks.forEach(task => {
      let taskDate: Date = parseJSON(task.taskDueDate!)
      if (userID == task.taskAssigneeID) {
        if (task.taskStatus == 0) {
          if (
            taskDate > currentDate &&
            taskDate < endOfWeek(currentDate, { weekStartsOn: 1 })
          ) {
            counter++
          }
        }
      }
    })
    return counter
  }

  overdueTasks(taskID: any) {
    let counter = 0

    this.tasks.forEach(task => {
      if (
        this.isTaskOverDue(task.taskDueDate!) &&
        task.taskAssigneeID == taskID &&
        task.taskStatus == 0
      ) {
        counter++
      }
    })

    return counter
  }

  //gets a task based on taskID from list of tasks
  getTask(taskID: string | number) {
    return find(this.tasks, { taskID })
  }

  //formats the date to a nicer look
  formatTimestamp(timestamp) {
    return format(parseISO(timestamp), "dd MMM yyyy")
  }

  isTaskOverDue(taskDate: string) {
    return (
      parseJSON(taskDate) < endOfToday() && parseJSON(taskDate) < startOfToday()
    )
  }

  filterTasks(taskAssigneeID: any, viewCompleted: number) {
    if (viewCompleted == 1) {
      return filter(this.tasks, { taskAssigneeID })
    } else {
      return filter(this.tasks, { taskAssigneeID, taskStatus: 0 })
    }
  }
}
